import { IBaseWidget } from '../../../../IBaseWidget';

/**
 * Controlla se lato interfaccia di configurazione è stato impostato di
 * nascondere l'etichetta del widget.
 */
export function hasWidgetHiddenLabel(widget: IBaseWidget) {
  return (
    widget.layout &&
    'hideLabel' in widget.layout &&
    (widget.layout.hideLabel as boolean | undefined)
  );
}
